import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(() => ({
  header: {
    zIndex: 98,
    boxSizing: 'border-box',
    height: '65px'
  }
}));

export default createClasses;
